const CopilotOverlay = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center z-50 opacity-100 border-brand-primary">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <h3 className="text-xl font-semibold mb-2">Drop Files Here</h3>
        <p className="text-gray-600">
          Release to upload your files (max 3 files)
        </p>
        <p className="text-sm text-gray-500 mt-2">
          Accepted file types: PDF, Excel, JPG, PNG, DOC
        </p>
      </div>
    </div>
  );
};

export default CopilotOverlay;
